import { ILibraryOpeningHours } from '../../queries/fragments/libraryOpeningHours';
import { ILibraryOpeningHoursException } from '../../queries/fragments/libraryOpeningHoursException';
import { IMeetingPlacePageTenantEntertainmentList } from '../../queries/fragments/meetingPlacePageTenantEntertainmentList';
import { IMeetingPlacePageTenantFoodBeverageList } from '../../queries/fragments/meetingPlacePageTenantFoodbeverageList';
import { IMeetingPlacePageTenantList } from '../../queries/fragments/meetingPlacePageTenantList';
import { IMeetingPlacePageTenantShopList } from '../../queries/fragments/meetingPlacePageTenantShopList';
import { PageContext } from '../../templates/page-context.interface';
import { generateCorrectSlug } from '../generate-correct-slug';

export interface tenantListMeetingPlacePageHome {
  meetingPlace: {
    timezone: string;
    integrationId: string;
    businessUnitCode: string;
    showSocialShare: boolean;
    openingHours: ILibraryOpeningHours;
    openingHoursExceptions: ILibraryOpeningHoursException[];
    tenantListPage?: IMeetingPlacePageTenantList;
    tenantShopListPage: IMeetingPlacePageTenantShopList;
    tenantFoodBeverageListPage?: IMeetingPlacePageTenantFoodBeverageList;
    tenantEntertainmentListPage?: IMeetingPlacePageTenantEntertainmentList;
  };
}

export const extractTenantData = (
  homepage: tenantListMeetingPlacePageHome,
  pageContext: PageContext,
) => {
  const shopList = homepage?.meetingPlace?.tenantShopListPage?.shopItems;
  const foodBevList =
    homepage?.meetingPlace?.tenantFoodBeverageListPage?.foodBeverageItems;
  const entertainmentList =
    homepage?.meetingPlace?.tenantEntertainmentListPage?.entertainmentItems;
  const tenantList = homepage?.meetingPlace?.tenantListPage?.tenants || [];

  const allItems = [
    ...(shopList ? shopList : []),
    ...(foodBevList ? foodBevList : []),
    ...(entertainmentList ? entertainmentList : []),
  ];

  tenantList.forEach((tenant: any) => {
    if (!allItems.some((item) => item.id === tenant.id)) {
      allItems.push(tenant);
    }
  });

  return allItems.map((tenant) => {
    const slug = tenant.slug || tenant.brand?.slug || '';

    const tenantSlug = generateCorrectSlug({
      customizedSlug: tenant.customizedSlug,
      name: tenant.name,
      node_locale: pageContext?.language,
      slug,
    });

    return {
      name: tenant.name || tenant.brand?.name || '',
      openingHours: tenant.openingHours ?? null,
      openingHoursExceptions: tenant?.openingHoursExceptions ?? null,
      timezone: homepage?.meetingPlace?.timezone ?? '',
      slug: tenantSlug,
    };
  });
};
